import { useShallow } from 'zustand/shallow'

import { useStore, getNodesObjectsSelector } from '@app/store'

const useGetNodeDomainObjects = (
  nodes: Parameters<typeof getNodesObjectsSelector>[1]
): ReturnType<typeof getNodesObjectsSelector> => useStore(useShallow((state) => getNodesObjectsSelector(state, nodes)))

export default useGetNodeDomainObjects
